import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Input, EventEmitter, Output, SimpleChanges, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { IItem } from '../../../models/IItem';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TimeLeftService } from '../../../services/time-left.service';
import { ApiService } from '../../../services/api.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DefaultImageComponent } from "../../auctions/default-image/default-image.component";

@Component({
  selector: 'app-item-vertical-view',
  imports: [NgIf, NgFor, CommonModule, ButtonModule, RouterModule, ProgressSpinnerModule, DefaultImageComponent],
  templateUrl: './item-vertical-view.component.html',
  styleUrl: './item-vertical-view.component.scss'
})
export class ItemVerticalViewComponent {
  protected readonly timeLeftService = inject(TimeLeftService);
  @Input() items: IItem[] = [];
  @Input() isHomePage: boolean = true;
  @Input() itemId!: number;
  @Output() openModal = new EventEmitter<number>();
  @Input() auctionId!: number;

  isClosed!: boolean;

  private readonly apiService = inject(ApiService)


  sanitizedItems: Array<IItem & { safeDescription?: SafeHtml }> = [];

  constructor(private sanitizer: DomSanitizer) {
  }

  onOpenModalVertical(id: number) {
    this.openModal.emit(id);
    // console.log(id);
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.sanitizedItems = this.items.map(item => ({
        ...item,
        description: item.description,
        safeDescription: this.sanitizeHtmlText(item.description!),
        safeName: this.sanitizeHtmlText(item.name!)
      }));

    }

  }

  sanitizeHtmlText(content: string): SafeHtml {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const txt = document.createElement('textarea');
      txt.innerHTML = content;
      const decodedContent = txt.value;
      return this.sanitizer.bypassSecurityTrustHtml(decodedContent);
    }
    return '';
  }


  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }

}

